<!-- eslint-disable -->
<template lang="pug">
    .interactive-place
        .interactive-place__font-size-scaling-bar
            input.scaling-bar.cr-slider(
                type='range',
                @change="resizeText($event)",
                :step='stepFontSize',
                :min='minFontSize',
                :max='maxFontSize',
                :value='fontSize'
            )
            .scale-text-info {{ $i18n.t('trainer.trainer_game_shutter_scale', {element: $i18n.tc('trainer.trainer_gamePlayBox_words')}) }}
        .buttons
            cs-button(
                pattern="primary-outline"
                @click="$emit('doneWithPreparing')"
            ) {{ $i18n.t('common.common_button_done') }}
        .test-text-container(:style="testTextContainerStyles")
            .test-text-container__row(
                :class="rowsName"
                v-for="word in displayedTestLines"
            )
                span {{ word }}
</template>

<script>
    const LINE = 'Тестовая строка. ';
    const LINE_REPETITIONS_NUMBER = 15;

    export default {
        props: {
            rowsName: String,
            fontSize: [Number, String],
            isTextMode: {
                type: Boolean,
                default: false,
            },
            amountOfWordsInRow: {
                type: Number,
                default: 0,
            },
            amountOfWordsInColumn: {
                type: Number,
                default: 0,
            },
        },
        data() {
            return {
                windowWidth: 0,
            };
        },
        computed: {
            amountOfWords() {
                return this.isTextMode ? this.amountOfWordsInRow : this.amountOfWordsInColumn;
            },
            displayedTestLines() {
                const line_number = !this.isTextMode ? this.amountOfWords : LINE_REPETITIONS_NUMBER;
                const text = LINE.repeat(line_number);
                if (!this.isTextMode) {
                    return _.take(text.match(/[^.!?]+[.!?"'»]+/g), this.amountOfWords);
                } else {
                    return _.chunk(text.split(' '), this.amountOfWords).map(arr => arr.join(' '));
                }
            },
            testTextContainerStyles() {
                return `font-size: ${this.fontSize}px`;
            },
            stepFontSize() {
                const size = Math.floor((this.maxFontSize - this.minFontSize) / 20);
                return size < 1 ? 1 : size;
            },
            minFontSize() {
                if (this.windowWidth < 1440) {
                    return this.isTextMode ? 12 : 36;
                } else if (this.windowWidth < 1600) {
                    return this.isTextMode ? 16 : 36;
                }
                return this.isTextMode ? 18 : 44;
            },
            maxFontSize() {
                if (!this.isTextMode) {
                    return Math.floor(this.windowWidth / 12);
                }
                return Math.floor((this.windowWidth / 90 + 10) * this.multiplier);
            },
            multiplier() {
                if (this.amountOfWordsInRow <= 5) {
                    return 2.6;
                }
                if (this.amountOfWordsInRow > 5 && this.amountOfWordsInRow <= 10) {
                    return 1.5;
                }
                return 1;
            },
        },
        created() {
            document.addEventListener('keydown', this.doneOnEnter);
        },
        beforeDestroy() {
            document.removeEventListener('keydown', this.doneOnEnter);
        },
        mounted() {
            this.windowWidth = window.innerWidth;
            this.$emit('setFontSize', this.minFontSize);
        },
        methods: {
            resizeText(event) {
                this.$emit('setFontSize', event.target.value);
            },
            doneOnEnter(event) {
                if (event.keyCode === 13) {
                    document.removeEventListener('keydown', this.doneOnEnter);
                    this.$emit('doneWithPreparing');
                }
            },
        },
    }
</script>

<style lang="scss" scoped>
    .buttons {
        margin-bottom: 30px;
        text-align: center;
    }

    .scale-text-info {
        font-size: 18px;
        @include media($lg) {
            font-size: 26px;
        }
        @include media($xlg) {
            font-size: 32px;
        }
    }

    .scaling-bar {
        -webkit-appearance: none;
        width: 50%;
        background: transparent;
        margin: 24px 0;
        &:focus {
            outline: none;
        }
        &::-webkit-slider-thumb {
            -webkit-appearance: none;
            height: 18px;
            width: 18px;
            border-radius: 50%;
            background: $hsl-color-green-58;
            margin-top: -6px;
            cursor: pointer;
        }
        &::-moz-range-thumb {
            -webkit-appearance: none;
            height: 18px;
            width: 18px;
            border-radius: 50%;
            background: $hsl-color-green-58;
            cursor: pointer;
        }
        &::-ms-thumb {
            -webkit-appearance: none;
            height: 18px;
            width: 18px;
            border-radius: 50%;
            background: $hsl-color-green-58;
            cursor: pointer;
        }
        &::-webkit-slider-runnable-track {
            width: 100%;
            height: 6px;
            cursor: pointer;
            background: #eaeaea;
            border-radius: 2px;
        }
    }

    .interactive-place {
        width: 100%;
        display: flex;
        flex-direction: column;
    }

    .interactive-place__font-size-scaling-bar {
        padding-top: 12px;
        text-align: center;
        margin-bottom: 28px;
    }

    .test-text-container {
        text-align: center;
        font-size: 18px;
        white-space: normal;
        overflow-x: hidden;
        overflow-y: auto;
        cursor: pointer;
        user-select: none;
        height: 100%;
        @media (orientation: landscape) {
            @include media($lg) {
                height: calc(100vh - 460px);
            }
        }
        @media (orientation: portrait) {
            @include media($sm) {
                height: calc(100vh - 415px);
            }
            @include media($md) {
                height: calc(100vh - 460px);
            }
        }
        @include scrollbar;
    }
</style>
